import { AxiosError, AxiosResponse } from "axios";
import ICustomer, { ICustomerWrap } from "@/types/customer";
import { getCustomer } from "@/apps/merchant3/services/customers.service";
import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import { EContract } from "@/apps/merchant3/models/IStateContract";

const actions = {
  loadCustomer: ({ commit }: ICommit, userTag: string): void => {
    getCustomer(userTag).then(
      (response: AxiosResponse<ICustomerWrap>) => {
        const { customer } = response.data;
        commit("SET_CUSTOMER", customer);
      },
      (error: AxiosError) => {
        if (error) console.log("ERROR_SOMETHING_GOES_WRONG");
      }
    );
  },
  setCustomer: ({ commit }: ICommit, payload: ICustomer): void => {
    commit("SET_CUSTOMER", payload);
  },
  resetCustomer: ({ commit }: ICommit): void => {
    commit("RESET_CUSTOMER");
  },
  setIsFraud: ({ commit }: ICommit, payload: EContract): void => {
    commit("SET_IS_FRAUD", payload);
  },
  setCustomerState: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CUSTOMER_STATE", payload);
  },
  setCustomerCity: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CUSTOMER_CITY", payload);
  },
  resetCustomerCity: ({ commit }: ICommit): void => {
    commit("RESET_CUSTOMER_CITY");
  },
  setCustomerPhone: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CUSTOMER_PHONE", payload);
  },

  setUserTag: ({ commit }: ICommit, payload: string): void => {
    console.log("customer/setUserTag", payload);
    commit("SET_USER_TAG", payload);
  },
};

export default actions;
